import { fetchEnrichedProjects } from '@/api/v4/project-enrich.api';
import { QueryKey } from '@/config/query-client';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { useQuery } from '@tanstack/react-query';

export const useEnrichedProjectSuggestions = (projectIds: string[]) => {
  const getEnrichedProjects = async () => {
    if (!projectIds.length) {
      return [];
    }

    return await fetchEnrichedProjects({
      projectIds,
    });
  };

  return useQuery({
    queryKey: [QueryKey.ProjectEnrichedSearchSuggestions, projectIds],
    queryFn: getEnrichedProjects,
    staleTime: getTimeInMs(5, 'minute'),
    gcTime: getTimeInMs(5, 'minute'),
  });
};
